export default __webpack_public_path__ + "static/media/10.1d668ce7.pdf";